import { createFileRoute } from "@tanstack/react-router";
import { ProjectUpdatesPage } from "@/components/updates/update-pages";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/updates")({
  component: ProjectUpdatesPage,
});
